// 05 — First water. REFOCUS §5 ends the first minute here, with the drinker
// filled by the player rather than discovered failing later from the chore bar.
//
// The fill is the ordinary water chore (`completeChore`), so it lands in the
// Veteran action log and the reading underneath it is the sim's own
// (`selectWaterView`) — the same numbers the coop screen will show all day.

import { t } from '../../i18n';
import { completeChore } from '../actions';
import { button, div, h } from '../dom';
import { selectWaterView } from '../selectors';
import type { Screen, ScreenContext } from '../router';
import { coopScreen } from './coop';

export function firstWaterScreen(): Screen<HTMLElement> {
  return {
    id: 'firstWater',
    render: (ctx: ScreenContext<HTMLElement>) => {
      const { store } = ctx.services;
      // Coming back from a reload lands here with the chore already done, so the
      // button is the way onward rather than a second fill.
      let filled = store.getState().progression.choresDoneToday.includes('water');

      const meterHost = div({ class: 'cf-card cf-stack cf-stack--tight' });
      const statusHost = div({});
      const foot = div({ class: 'cf-screen__foot' });

      const repaint = (): void => {
        const view = selectWaterView(store.getState());
        meterHost.replaceChildren(
          h('span', { class: 'cf-label', text: t('onboard.water.level', { level: view.level }) }),
          h('span', {
            class: `cf-small ${view.drinkable ? 'cf-muted' : 'cf-warn'}`,
            text: t(view.drinkable ? 'onboard.water.purity.good' : 'onboard.water.purity.bad'),
          }),
        );
        statusHost.replaceChildren(
          ...(filled ? [h('p', { class: 'cf-sub', text: t('onboard.water.filled') })] : []),
        );
        foot.replaceChildren(
          button({
            class: 'cf-btn cf-btn--primary',
            text: filled ? t('onboard.water.toCoop') : t('onboard.water.fill'),
            on: {
              click: () => {
                if (!filled) {
                  completeChore(store, 'water');
                  filled = true;
                  repaint();
                  return;
                }
                ctx.router.reset(coopScreen());
              },
            },
          }),
        );
      };

      const screen = div(
        { class: 'cf-screen' },
        div(
          { class: 'cf-screen__head' },
          h('span', { class: 'cf-eyebrow', text: t('onboard.step', { n: '5', of: '5' }) }),
        ),
        h('h1', { class: 'cf-display cf-display--sm', text: t('onboard.water.title') }),
        h('p', { class: 'cf-sub', text: t('onboard.water.subtitle') }),
        meterHost,
        statusHost,
        h('div', { class: 'cf-grow' }),
        foot,
      );
      repaint();
      screen.tabIndex = -1;
      return screen;
    },
  };
}
